// removed by extract-text-webpack-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-PrivacyStatement-absolute-center","privacy":"onfido-sdk-ui-PrivacyStatement-privacy","content":"onfido-sdk-ui-PrivacyStatement-content","actions":"onfido-sdk-ui-PrivacyStatement-actions","list":"onfido-sdk-ui-PrivacyStatement-list","item":"onfido-sdk-ui-PrivacyStatement-item","smallPrint":"onfido-sdk-ui-PrivacyStatement-smallPrint","decline":"onfido-sdk-ui-PrivacyStatement-decline","primary":"onfido-sdk-ui-PrivacyStatement-primary"};


//////////////////
// WEBPACK FOOTER
// ./components/PrivacyStatement/style.css
// module id = 315
// module chunks = 1